import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["target", "href", "className"];
import React from 'react';
import { getLabel, isInternalLink } from './MarkdownLink.utils';
import InternalLink from '../../../../atoms/InternalLink/InternalLink';
import OutboundLink from '../../../../atoms/OutboundLink/OutboundLink';
import { MARKDOWN_LINK_EVENT_CATEGORY } from '../../../../modules/analytics/components/Event/Event.constants';
import { AnalyticsAction } from '../../../../services/analytics/google/google-analytics.constants';
var defaultProps = {
  target: '',
  className: ''
};
export default function MarkdownLink(_ref) {
  var target = _ref.target,
    href = _ref.href,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var label = getLabel(href, rest);
  var event = {
    category: MARKDOWN_LINK_EVENT_CATEGORY,
    action: AnalyticsAction.CLICK,
    label: label,
    value: href
  };
  if (isInternalLink({
    href: href
  })) {
    return /*#__PURE__*/React.createElement(InternalLink, _extends({}, rest, {
      to: href,
      className: className,
      event: event
    }));
  }
  return /*#__PURE__*/React.createElement(OutboundLink, _extends({}, rest, {
    to: href,
    className: className,
    newTab: target === '_blank',
    event: event
  }));
}
MarkdownLink.defaultProps = defaultProps;